import { inject, Injectable } from "@angular/core";
import { Actions, createEffect, ofType } from "@ngrx/effects";
import { Store } from "@ngrx/store";
import { UserActions } from "./profile.actions";
import { map, switchMap, tap } from "rxjs";
import { AuthService } from "projects/shared/services/auth.service";

@Injectable()
export class UserEffect {
  store = inject(Store);
  actions = inject(Actions);
  authService = inject(AuthService);

  getUserEffect$ = createEffect(() => this.actions.pipe(
    ofType(UserActions.userLogin),
    tap(() => console.log('userLogin action received')),
    switchMap(() => this.authService.validate().pipe(
      tap(res => console.log('validate response:', res)),
      map(res => UserActions.getUser({data: res}))
    ))
  ));
}